import { Navigate } from "react-router-dom";

function PrivateRoutes({ children }) {
  const isLoggedIn = localStorage.getItem("adminToken");

  return isLoggedIn ? children : <Navigate to="/admin/login" replace />;
}

export default PrivateRoutes;
